export const createEmptyQuestionnaireState = (params) => {
    return Object.assign(Object.assign({}, params), { stepData: params.prefilledData, currentStepIndex: 0, editMode: false });
};
